import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import RatingStart from "../RatingStarNew";
import { composeArrayForRatings } from "../CommonMethods";
import ClaimProfile from "../Popups/ClaimProfile";

const ScrollHeaderVerified = (props) => {
  const history = useHistory();
  const [isUpgrade, setUpgrade] = useState(false);
  const setClaimProfilePopUpFalse = () => {
    setUpgrade(false);
  };

  return (
    <>
      {/* scrolledHeaderPopup fixed-header */}
      <div className="scrolledHeaderPopup">
        <div className="scrolledHeader_verified">
          <div className="left_section">
            <div className="logo">
              <img
                src={props?.vendorCommon?.logo}
                alt=""
                width={140}
                height={70}
              />
            </div>
            <div className="text_block">
              <span className="heading_txt">{`${props?.vendorCommon?.name} References Capped?`}</span>
              <p>
                Access even more references from these marketplace competitors
              </p>
              <div className="footer_text_block">
                <div className="txt">
                  {`Work at`}
                  <br />
                  {`${props?.vendorCommon?.name}?`}
                </div>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setUpgrade(true);
                  }}
                  className="upgradeprofile"
                >
                  Upgrade Profile
                </a>
              </div>
            </div>
          </div>
          <div className="middle_section">
            <ul>
              {props?.vendorCommon?.competitors?.map((obj, index) => (
                <li key={`spons_${index}${obj.profile_url}`}>
                  <div
                    className={"logo"}
                    onClick={(e) => {
                      e.preventDefault();
                      //history.push(obj.profile_url);
                    }}
                  >
                    <Link to={obj.profile_url}>
                      <img src={obj?.logo} alt="" width={150} height={32} />
                    </Link>
                  </div>

                  {!!obj?.rating?.aggregate_score && (
                    <div className="starRating">
                      <RatingStart
                        starCount={composeArrayForRatings(
                          obj?.rating?.aggregate_score
                        )}
                        profile
                        rated_by_user_count={obj?.rating?.rated_by_user_count}
                        withoutO
                        useClass={"rating"}
                      />
                      <div className="ratingTxt">
                        {`${obj?.rating?.aggregate_score} / 5.0`}{" "}
                        {!!obj?.rating?.rated_by_user_count && (
                          <span className="totalReferences">
                            ({`${obj?.rating?.rated_by_user_count}`})
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  {!!obj.is_sponsored ? (
                    <div className="clsBadgeBlock">
                      <span className="clsBadge badgeSponsored">Sponsored</span>
                      <span className="txt">
                        {obj?.reviews_count}+ References
                      </span>
                    </div>
                  ) : obj.type === "verified" ? (
                    <div className="clsBadgeBlock">
                      <span className="clsBadge badgeVerified">Verified</span>
                      <span className="txt">
                        {obj?.reviews_count}+ References
                      </span>
                    </div>
                  ) : obj.type === "premium" ? (
                    <div className="clsBadgeBlock">
                      <span className="clsBadge badgePremium">Premium</span>
                      <span className="txt">
                        {obj?.reviews_count}+ References
                      </span>
                    </div>
                  ) : (
                    <div className="clsBadgeBlock">
                      <span className="txt">
                        {obj?.reviews_count}+ References
                      </span>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
          {/* <div className="right_section">
            <span className="txt">{`Work at ${props?.vendorCommon?.name}?`}</span>
            <div
              className="browse_btn clsCursor"
              onClick={(e) => {
                e.preventDefault();
                setUpgrade(true);
              }}
            >
              <a href="#upgrade_your_profile_pupup">Upgrade Your Profile</a>
            </div>
          </div> */}
        </div>
      </div>
      {isUpgrade && (
        <ClaimProfile setClaimProfilePopUpFalse={setClaimProfilePopUpFalse} />
      )}
    </>
  );
};

export default ScrollHeaderVerified;
